import { Repository } from '@models/Repository';

import api from './api';

export async function getUserRepositories(username: string, page = 1) {
  const params = {
    page,
  };
  const { data } = await api.get<Repository[]>(`/users/${username}/repos`, {
    params,
  });

  return data;
}
